import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import BackArrowMenu from '../../UI/BackArrowMenu';
import LeftSidePopup from '../../UI/LeftSidePopup'
import VerticalMenu from '../../UI/VerticalMenu'
import * as PathRouter from '../../../models/PathRoute'
import classes from "./AdminLayout.module.css";
import { getCoursesData } from '../../../store/discipline-action';
import Permissions from '../../Permissions';
import { UserActivityEnum } from '../../../models/UserActivityEnum';
import ScrollLTR from '../../lms-shared/UI/ScrollLTR';
import { selectDisciplinesCurrentYear } from '../../../store/discipline-slice';

const AdminLayout = () => {
    const texts = useSelector((state) => state.translate.texts);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { applicationId, homeUrl } = useSelector((state) => state.application);

    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state));
    const location = useLocation()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    useEffect(() => {
        if (!disciplines && applicationId)
            dispatch(getCoursesData());
    }, [applicationId])

    useEffect(() => {
        setCurrentIndex(tabs.map(x => x.link).findIndex((p) => location.pathname.toLowerCase().includes(p.toLowerCase())))
    }, [location.pathname])

    const tabs = [
        { name: texts.professionsTitle, link: PathRouter.DISCIPILINES, permission: UserActivityEnum.EditCourse },
        { name: texts.messages, link: PathRouter.MESSAGES, permission: UserActivityEnum.AddAlarms },
        { name: texts.teacherbanner, link: PathRouter.TEACHER_BANNER, permission: UserActivityEnum.EditBanner },
        { name: texts.studentbanner, link: PathRouter.STUDENT_BANNER, permission: UserActivityEnum.EditBanner },
        { name: texts.filterPosts, link: PathRouter.POSTS, permission: UserActivityEnum.DeletePosts },
        { name: texts.trainings, link: PathRouter.TRANINGS, permission: UserActivityEnum.AddTraining },
        { name: texts.monitoringSchools, link: PathRouter.GUIDE, permission: UserActivityEnum.LearningSupervision },
    ]

    return <div className={classes.AdminLayout}>
        <LeftSidePopup>
            <BackArrowMenu title={texts.adminManegment} onClick={() => { navigate(`${homeUrl}/admin`) }} />
            <VerticalMenu currentIndex={currentIndex}>
                {[<Permissions key={tabs[0].name} title={tabs[0].name} onClick={() => { navigate(`./${tabs[0].link}`) }} activityType={tabs[0].permission}>
                    {disciplines &&
                        <ScrollLTR dropStyle={{ height: "calc(100vh - 395px)", marginRight: "5px" }}>
                            <VerticalMenu currentIndex={id && disciplines && disciplines.findIndex(d => d.id === id)}>
                                {disciplines.map(d => <div key={d.id} className={classes.DiscplineName} title={d.name} onClick={() => { navigate(`./${PathRouter.DISCIPILINES}/${d.id}`) }}></div>)}
                            </VerticalMenu>
                        </ScrollLTR>}
                </Permissions>,
                ...tabs.filter((t, i) => i !== 0).map(t => <Permissions key={t.link} activityType={t.permission} title={t.name} onClick={() => { navigate(`./${t.link}`) }}></Permissions>)]}
            </VerticalMenu>
        </LeftSidePopup>
        <div className={classes.Outlet}>
            <div className={classes.RTL}>
                <div className={classes.Title}>{tabs[currentIndex]?.name}</div>
                <Outlet></Outlet>
            </div>
        </div>
    </div>
}

export default AdminLayout